import EditIcon from '@mui/icons-material/Edit';
import RecentActorsIcon from '@mui/icons-material/RecentActors';

function EditBillingUserIcon() {
    return (
        <div style={{ maxWidth: "24px" }}>
            <RecentActorsIcon />
            <EditIcon sx={{ fontSize: "15px", marginLeft: "-10px", color: "black" }} />
        </div>
    )
}

export default EditBillingUserIcon;